export const cardContent = {
  padding: "16px 16px",
  backgroundColor: "transparent",
};
